import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: true,
      marketing: true,
      date: new Date().toISOString()
    }));
    setVisible(false);
  };

  const manage = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: false,
      marketing: false,
      date: new Date().toISOString()
    }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          key="cookie-consent"
          className="cookie-banner__dock"
          role="presentation"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 220, damping: 28 }}
        >
          <div
            className="cookie-banner"
            role="dialog"
            aria-modal="false"
            aria-label="Cookie consent"
          >
            <div className="cookie-banner__text">
              <p className="cookie-banner__copy">
                We use cookies to enhance your experience, analyse site traffic, and personalise content.
                By choosing &quot;Accept All&quot;, you consent to our use of cookies.{' '}
                <Link to="/cookie-policy" className="cookie-banner__link">
                  Learn more
                </Link>
              </p>
            </div>
            <div className="cookie-banner__actions">
              <button
                type="button"
                onClick={manage}
                className="cookie-banner__btn cookie-banner__btn--secondary"
              >
                Essential Only
              </button>
              <motion.button
                type="button"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={accept}
                className="cookie-banner__btn cookie-banner__btn--primary"
              >
                Accept All
              </motion.button>
            </div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default CookieBanner;
